mutation DisableSecondFactor($code: String!) {
  disableSecondFactor(input: { code: $code }) {
    success
  }
}
